import { Field } from '@fluentui/react-components';
import { CategoryStateProps } from '../../hooks/useDeviceFormHook';
import { useDeviceDrawerStore } from '../../store/DeviceDrawerStore';
import BodyPresenceMotion from './BodyPresenceMotion';
import BaseOptionCombobox from '../../../../components/BaseOptionCombobox';

type ISOInfoProps = {
    styles: string;
    availabilityState: CategoryStateProps;
    integrityState: CategoryStateProps;
    confidentialityState: CategoryStateProps;
}

export default function ISOInfo({ styles, availabilityState, integrityState, confidentialityState }: ISOInfoProps) {
    const { isForward, level } = useDeviceDrawerStore();

    return (
        <BodyPresenceMotion
            isForward={isForward}
            visible={level === 3}
            unmountOnExit={true}
        >
            <div className={styles}>

                <Field label={"Availability"} required={true} >
                    <BaseOptionCombobox
                        id={availabilityState.id}
                        data={availabilityState.list?.options}
                        defaultValue={availabilityState.value.toString()}
                        disabled={false}
                        onChange={availabilityState.setValue}
                    />
                </Field>

                <Field label={"Integrity"} required={true} >
                    <BaseOptionCombobox
                        id={integrityState.id}
                        data={integrityState.list?.options}
                        defaultValue={integrityState.value.toString()}
                        disabled={false}
                        onChange={integrityState.setValue}
                    />
                </Field>

                <Field label={"Confidentiality"} required={true} >
                    <BaseOptionCombobox
                        id={confidentialityState.id}
                        data={confidentialityState.list?.options}
                        defaultValue={confidentialityState.value.toString()}
                        disabled={false}
                        onChange={confidentialityState.setValue}
                    />
                </Field>

            </div>

        </BodyPresenceMotion>
    );
}